'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Menu_1 = require("./App/Menu");
var Setup_1 = require("./Setup");
var Game_1 = require("./Game");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.resizeTimeoutId = null;
        _this.windowFacade = {
            getViewportDimensions: function () {
                return ({ width: window.innerWidth, height: window.innerHeight });
            },
            addEventListener: function (type, listener, options) {
                window.addEventListener(type, listener, options);
            },
            removeEventListener: function (type, listener, options) {
                window.removeEventListener(type, listener, options);
            },
        };
        _this.state = {
            gameConfig: null,
            viewport: null,
            gameId: "game-" + Date.now(),
        };
        _this.handleNewGame = _this.handleNewGame.bind(_this);
        _this.handleResetGame = _this.handleResetGame.bind(_this);
        _this.handleStart = _this.handleStart.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.stopResizeHandling = _this.stopResizeHandling.bind(_this);
        return _this;
    }
    /**
     * Handles clicks on the "New Game" button.
     */
    App.prototype.handleNewGame = function () {
        this.stopResizeHandling();
        this.setState({ gameConfig: null, viewport: null });
    };
    /**
     * Handles clicks on the "Reset Game" button.
     */
    App.prototype.handleResetGame = function () {
        this.setState({ gameId: "game-" + Date.now() });
    };
    /**
     * Handles clicks on the "Start Game" button.
     */
    App.prototype.handleStart = function (config) {
        this.setState({
            gameConfig: config,
            viewport: this.windowFacade.getViewportDimensions(),
        });
        this.windowFacade.addEventListener('resize', this.handleResize);
    };
    /**
     * Handles a "resize" event on the viewport.
     */
    App.prototype.handleResize = function () {
        var _this = this;
        if (this.resizeTimeoutId === null) {
            this.resizeTimeoutId = global.setTimeout(function () {
                _this.resizeTimeoutId = null;
                _this.setState({
                    viewport: _this.windowFacade.getViewportDimensions(),
                });
            }, 33);
        }
    };
    /**
     * Executes the cleanup necessary to stop listening and handling to "resize"
     * events.
     */
    App.prototype.stopResizeHandling = function () {
        if (this.resizeTimeoutId !== null) {
            global.clearTimeout(this.resizeTimeoutId);
        }
        this.windowFacade.removeEventListener('resize', this.handleResize);
    };
    App.prototype.componentWillUnmount = function () {
        this.stopResizeHandling();
    };
    App.prototype.render = function () {
        var children = [];
        if (this.state.gameConfig !== null && this.state.viewport !== null) {
            children.push(React.createElement(Menu_1.Menu, { key: 'menu', onNewGame: this.handleNewGame, onResetGame: this.handleResetGame }));
            children.push(React.createElement(Game_1.Game, { key: this.state.gameId, viewport: this.state.viewport, gameConfig: this.state.gameConfig }));
        }
        else {
            children.push(React.createElement(Setup_1.Setup, { key: 'setup', onStart: this.handleStart }));
        }
        return (React.createElement("div", { id: 'app', style: Styles.app }, children));
    };
    return App;
}(React.Component));
exports.App = App;
//# sourceMappingURL=App.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/App.js
// module id = 25
// module chunks = 0